module.exports = __webpack_public_path__ + "static/media/pratyushTitle.dc949d1a.png";